import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DisplayHideContentAnimation } from 'src/app/rek-client-app/shared/animations/display-hide-content.animation';
import { OpenCloseAnimation } from 'src/app/rek-client-app/shared/animations/open-close.animation';
import { DynamicComponentHost } from 'src/app/shared/modules/dynamic-components/dynamic-component-host.component';
import { DynamicComponentHostDirective } from 'src/app/shared/modules/dynamic-components/dynamic-component-host.directive';
import { AccordionType } from '../models/accordion-type.model';
import { AccordionsGroupOptions } from '../models/accordions-group-options.model';
import { Accordion } from './accordion.model';

@Component({
  selector: 'rek-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [
    OpenCloseAnimation(),
    DisplayHideContentAnimation()
  ]
})
export class AccordionComponent extends DynamicComponentHost implements OnInit {
  readonly AccordionType = AccordionType;

  @Input() readonly accordionItem: Accordion;
  @Input() readonly accordionOptions: AccordionsGroupOptions;
  @Input() readonly index?: number;
  @Output() readonly toggle = new EventEmitter<Accordion>();

  @ViewChild(DynamicComponentHostDirective, { static: true }) dynamicComponentHost: DynamicComponentHostDirective;

  constructor(protected componentFactoryResolver: ComponentFactoryResolver) {
    super(componentFactoryResolver);
  }

  ngOnInit() {
    if (!this.accordionItem || !this.accordionOptions) {
      throw new Error('Accordion item and options must be supplied');
    }

    super.initHost(this.dynamicComponentHost);
    super.renderComponentForItem(this.accordionItem.componentToRenderData);
  }
}
